import { useNavigate, useLocation } from 'react-router-dom';
import { CompassIcon, GridIcon, ChatBubbleIcon, UserIcon } from '../../utils/icons';

const styles = {
  nav: {
    position: 'fixed',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '480px',
    display: 'flex',
    background: 'var(--bg-surface)',
    borderTop: '1px solid var(--border-color)',
    boxShadow: '0 -1px 4px rgba(0, 0, 0, 0.04)',
    padding: '8px 0',
    zIndex: 50,
  },
  tab: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 0',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    color: 'var(--text-muted)',
    fontSize: '11px',
    fontWeight: '500',
    transition: 'color 200ms',
    position: 'relative',
  },
  tabActive: {
    color: 'var(--accent)',
  },
  icon: {
    lineHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badge: {
    position: 'absolute',
    top: '2px',
    right: 'calc(50% - 18px)',
    background: 'var(--accent)',
    color: '#fff',
    fontSize: '10px',
    fontWeight: '700',
    minWidth: '16px',
    height: '16px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 4px',
  },
};

const tabs = [
  { path: '/discover', label: 'Discover', Icon: CompassIcon },
  { path: '/wall', label: 'Wall', Icon: GridIcon },
  { path: '/matches', label: 'Matches', Icon: ChatBubbleIcon },
  { path: '/profile', label: 'Profile', Icon: UserIcon },
];

export default function BottomNav({ unreadCount = 0 }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav style={styles.nav}>
      {tabs.map((tab) => {
        const isActive =
          location.pathname === tab.path ||
          (tab.path === '/matches' && location.pathname.startsWith('/chat'));

        return (
          <button
            key={tab.path}
            style={{ ...styles.tab, ...(isActive ? styles.tabActive : {}) }}
            onClick={() => navigate(tab.path)}
          >
            <span style={styles.icon}><tab.Icon size={22} /></span>
            <span>{tab.label}</span>
            {tab.path === '/matches' && unreadCount > 0 && (
              <span style={styles.badge}>{unreadCount > 9 ? '9+' : unreadCount}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
